import { zipForm, infoWindowContent, becomeDealerForm } from './custom_forms';
import { alert } from './utils';
import { translations } from "./content/translations";

//let lang = localStorage.getItem("user_language");
let lang = "en";

if (!lang) {
    lang = Object.keys(languages).find((language) => language === navigator.language?.slice(0, 2)) || "en";
    localStorage.setItem("user_language", lang);
}

let dealersData = [];
let infoWindow = undefined;

const setMarker = (dealer, bounds, map) => {
    const pos = new google.maps.LatLng(dealer.geo_lat, dealer.geo_lng);

    const marker = new google.maps.Marker({
        map,
        position: pos,
        title: dealer.name,
    });

    bounds.extend(pos);

    marker.addListener("click", () => {
        if (infoWindow) infoWindow.close();
        infoWindow = new window.google.maps.InfoWindow({
            content: infoWindowContent(dealer),
            ariaLabel: dealer.name,
        });
        infoWindow.open({ anchor: marker, map });
    });
};

// Haversine в милях
function haversineMi(a, b) {
    const toRad = d => d * Math.PI / 180;
    const R = 3958.7613;
    const dLat = toRad(b.lat - a.lat);
    const dLng = toRad(b.lng - a.lng);
    const sa = Math.sin(dLat/2)**2 +
        Math.cos(toRad(a.lat)) * Math.cos(toRad(b.lat)) * Math.sin(dLng/2)**2;
    return 2 * R * Math.asin(Math.sqrt(sa));
}

async function geocodeAddress(address) {
    try {
        const response = await fetch(`https://nominatim.openstreetmap.org/search?format=json&q=${encodeURIComponent(address)}`);
        const data = await response.json();
        if (data.length) {
            return { lat: parseFloat(data[0].lat), lng: parseFloat(data[0].lon) };
        }
    } catch (err) {
        console.error(`${translations.geocodingFailed[lang]}:`, err);
    }
    return null;
}

export const getInputsData = async (event) => {
    event.preventDefault();
    const form = document.querySelector("#zipCodeForm");
    const distanceLimit = Number(form.distance.value || form.distance.placeholder || 0);

    const address = form.zipCode.value + ", " + form.country.value;
    if (!address.trim()) {
        alert(translations.enterAddress[lang], "warning");
        return;
    }

    // Instead of geolocation, geocode the entered address
    const user = await geocodeAddress(address);
    if (!user) {
        alert(translations.couldFindAddress[lang], "warning");
        return;
    }

    if (!dealersData.length) await getDealers();

    dealersData = dealersData.map(d => {
        if (d.geo_lat != null && d.geo_lng != null) {
            d.distanceMi = haversineMi(user, { lat: d.geo_lat, lng: d.geo_lng });
        } else {
            d.distanceMi = Infinity;
        }
        return d;
    });

    const filtered = distanceLimit
        ? dealersData.filter(d => d.distanceMi < distanceLimit)
        : dealersData;

    if (filtered.length) {
        filtered.sort((a, b) => (a.distanceMi ?? Infinity) - (b.distanceMi ?? Infinity));
        renderMap(filtered);
    } else {
        alert(translations.noDealer[lang], "warning");
    }

    document.getElementById("liveAlertPlaceholder")?.firstChild?.remove();
};


export const getDealers = async () => {
    const response = await fetch("/get-dealers", {method: "GET"});
    if (response.status === 200) {
        const result = await response.json();
        dealersData = result;
    }
}

export const renderMap = async (filteredData) => {
    const mapBlock = document.querySelector(".map");
    if (!mapBlock) return;

    mapBlock.innerHTML = "";
    if (!filteredData) await getDealers();

    const map = new google.maps.Map(mapBlock, {
        zoom: 3,
        gestureHandling: "cooperative",
        mapTypeId: google.maps.MapTypeId.ROADMAP,
    });

    const bounds = new google.maps.LatLngBounds();
    const data = (filteredData || dealersData)
        .filter(d => d.geo_lat != null && d.geo_lng != null)
        .sort((a, b) => (a.distanceKm ?? Infinity) - (b.distanceKm ?? Infinity));

    data.forEach(dealer => setMarker(dealer, bounds, map));

    if (!bounds.isEmpty()) {
        map.fitBounds(bounds);
    }
};

export const dealersForm = () => {
    const dealersBlock = document.createElement('div');
    const mapBlock = document.createElement("div");
    const becomeDealer = document.createElement('div');
    const buttonsWrapper = document.createElement('div');

    dealersBlock.classList.add('dealer_block');
    mapBlock.classList.add('map');
    becomeDealer.classList.add('btn', 'become-dealer');
    becomeDealer.id = "getDealerForm";

    becomeDealer.innerText = translations.becomeDealer[lang].toUpperCase();

    dealersBlock.innerHTML = zipForm(lang);
    dealersBlock.appendChild(mapBlock);
    dealersBlock.innerHTML += becomeDealerForm(lang);
    buttonsWrapper.appendChild(becomeDealer);
    dealersBlock.appendChild(buttonsWrapper);

    return dealersBlock
}

export const becomeDealerLogic = () => {
    const closeModal = document.querySelector(".btn-close");
    const modal = document.querySelector(".become-dealer_form");
    const nextButton = document.querySelector(".dealer-next");
    const previousButton = document.querySelector(".dealer-previous");
    const first = document.querySelector("#firstStep");
    const second = document.querySelector("#secondStep");

    modal && (modal.style.display = "block");
    closeModal && (closeModal.onclick = () => (modal && (modal.style.display = "none")));
    nextButton && (nextButton.onclick = () => {
        first && first.classList.add("hide_block");
        second && second.classList.remove("hide_block");
    })
    previousButton && (previousButton.onclick = () => {
        first && first.classList.remove("hide_block");
        second && second.classList.add("hide_block");
    })
}

export const resetInputs = (event) => {
    event.preventDefault();
    event.target.form.zipCode.value = "";
    event.target.form.country.value = "";
    event.target.form.distance.value = "";
    renderMap();
}